import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Box,
} from "@mui/material";
import {
  People as PeopleIcon,
  Business as BusinessIcon,
  ShoppingCart as ShoppingCartIcon,
  Receipt as ReceiptIcon,
  Build as BuildIcon,
} from "@mui/icons-material";
import { Layout } from "../components/Layout";
import { useAuth } from "../context/AuthContext";

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const menuItems = [
    {
      title: "Patients",
      description: "Search and manage patient records",
      icon: <PeopleIcon sx={{ fontSize: 60 }} />,
      path: "/patients",
      color: "#1976d2",
    },
    {
      title: "Clients",
      description: "Manage client accounts and contacts",
      icon: <BusinessIcon sx={{ fontSize: 60 }} />,
      path: "/clients",
      color: "#0288d1",
    },
    {
      title: "Purchase Orders",
      description: "Create and manage purchase orders",
      icon: <ShoppingCartIcon sx={{ fontSize: 60 }} />,
      path: "/purchase-orders",
      color: "#2e7d32",
    },
    {
      title: "Invoices",
      description: "Create and manage client invoices",
      icon: <ReceiptIcon sx={{ fontSize: 60 }} />,
      path: "/invoices",
      color: "#9c27b0",
    },
    {
      title: "Utilities",
      description: "Import enrollments and admin tools",
      icon: <BuildIcon sx={{ fontSize: 60 }} />,
      path: "/utilities",
      color: "#ed6c02",
    },
  ];

  return (
    <Layout>
      <Box>
        <Typography variant='h4' gutterBottom>
          Welcome, {user?.firstname}!
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ mb: 4 }}>
          Select an option below to get started
        </Typography>

        <Grid container spacing={3}>
          {menuItems.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.path}>
              <Card>
                <CardActionArea onClick={() => navigate(item.path)}>
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        p: 2,
                      }}
                    >
                      <Box sx={{ color: item.color, mb: 2 }}>{item.icon}</Box>
                      <Typography variant='h5' component='div' gutterBottom>
                        {item.title}
                      </Typography>
                      <Typography
                        variant='body2'
                        color='text.secondary'
                        align='center'
                      >
                        {item.description}
                      </Typography>
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Layout>
  );
};

export default DashboardPage;
